import {FrameProfileType} from "./frame-profile";

export function getFrameProfileType(productCode: string): FrameProfileType|null {
    switch (productCode.toLowerCase()) {
        case 'p-17839':
            return "frame profile 50x70";
        case 'p-17061':
            return 'frame profile 70x78';
        default:
            return 'no frame profile';
    }
}